import './HomePage.css';

const HomePage = ({ onNavigate, documents }) => {
  const totalDocs = Object.values(documents).reduce((acc, arr) => acc + arr.length, 0);

  const features = [
    {
      title: 'Film Analysis',
      description: 'Deep dives into cinematic technique, narrative structure, and visual storytelling',
      icon: '◇',
      page: 'analyses',
      count: documents.analyses.length
    },
    {
      title: 'Screenplays',
      description: 'Fountain-formatted scripts with automatic rendering and analysis',
      icon: '◈',
      page: 'screenplays',
      count: documents.screenplays.length
    },
    {
      title: 'Research Notes',
      description: 'Interconnected ideas, theories, and observations on cinema',
      icon: '◉',
      page: 'notes',
      count: documents.notes.length
    },
    {
      title: 'Visual Essays',
      description: 'Image-driven explorations of film aesthetics and visual language',
      icon: '◊',
      page: 'essays',
      count: documents.essays.length
    }
  ];

  return (
    <div className="home-page">
      <div className="hero">
        <div className="hero-content">
          <h1 className="hero-title">
            Cinema Apparatus
          </h1>
          <p className="hero-subtitle">
            A research laboratory for film analysis, cinematic theory, and creative exploration
          </p>
          <div className="hero-stats">
            <div className="stat">
              <div className="stat-value">{totalDocs}</div>
              <div className="stat-label">Documents</div>
            </div>
            <div className="stat">
              <div className="stat-value">{documents.analyses.length}</div>
              <div className="stat-label">Analyses</div>
            </div>
            <div className="stat">
              <div className="stat-value">{documents.screenplays.length}</div>
              <div className="stat-label">Screenplays</div>
            </div>
          </div>
        </div>
      </div>

      <div className="features-grid">
        {features.map((feature, index) => (
          <div
            key={feature.page}
            className="feature-card"
            onClick={() => onNavigate(feature.page)}
            style={{ animationDelay: `${index * 0.1}s` }}
          >
            <div className="feature-icon">{feature.icon}</div>
            <div className="feature-content">
              <h3 className="feature-title">{feature.title}</h3>
              <p className="feature-description">{feature.description}</p>
              <div className="feature-count">{feature.count} items</div>
            </div>
            <div className="feature-arrow">→</div>
          </div>
        ))}
      </div>

      <div className="home-actions">
        <button className="action-card" onClick={() => onNavigate('graph')}>
          <div className="action-icon">◬</div>
          <div className="action-content">
            <h3 className="action-title">Graph View</h3>
            <p className="action-description">
              Explore connections between films, themes, and analyses
            </p>
          </div>
        </button>
      </div>

      <div className="home-info">
        <div className="info-section">
          <h3>About This Space</h3>
          <p>
            Cinema Apparatus is a digital research environment designed for deep engagement
            with film. It supports Markdown and HTML for written analysis, Fountain files
            for screenplay formatting, and Obsidian-style linking to create a web of
            interconnected ideas about cinema.
          </p>
        </div>
        <div className="info-section">
          <h3>Features</h3>
          <ul>
            <li>Markdown & MDX support for rich text formatting</li>
            <li>Automatic Fountain screenplay rendering</li>
            <li>Internal linking with [[wikilinks]]</li>
            <li>Graph visualization of relationships</li>
            <li>Local-first storage (no backend required)</li>
            <li>Export to static HTML</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default HomePage;
